export const AI_PROCESSING_ASSET_TYPES = {
  AUDIT: 'AUDIT',
  TRACING: 'TRACING',
  CERTIFICATE: 'CERTIFICATE',
  CERTIFIED_MATERIALS: 'CERTIFIED_MATERIALS',
  CAP: 'CAP',
  COMPANY_DOCUMENTS: 'COMPANY_DOCUMENTS',
} as const;

export type AiProcessingAssetType =
  (typeof AI_PROCESSING_ASSET_TYPES)[keyof typeof AI_PROCESSING_ASSET_TYPES];

export const AI_PROCESSING_STATUSES = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  DISMISSED: 'DISMISSED',
} as const;

export type AiProcessingStatus =
  (typeof AI_PROCESSING_STATUSES)[keyof typeof AI_PROCESSING_STATUSES];
